import { useRouter } from "@tanstack/react-router";

import { Sidebar } from "@/components/ui/layout/sidebar/sidebar";

import type { JSX } from "react";

interface MainElementProps extends React.ComponentPropsWithoutRef<"main"> {
  children: React.ReactNode;
}

/**
 * Main element component that renders the main element of a page - the dominant content of the <body> of a document.
 * Note that only one main element is permitted in a HTML document.
 *
 * @param children - Page component children.
 * @returns JSX.Element - Rendered Page component.
 */
export const MainElement = (props: MainElementProps): JSX.Element => {
  const router = useRouter();
  const isAuthRoute = router.state.location.pathname.includes("/auth");
  const isFlowRoute = router.state.location.pathname.includes("/flows");
  const isCafDocumentBlock = router.state.location.pathname.includes(
    "/caf-documents-blocked",
  );

  const showSidebar = !isAuthRoute && !isFlowRoute && !isCafDocumentBlock;

  return (
    <div className="flex h-screen-with-fallback overflow-hidden bg-white">
      {showSidebar ? <Sidebar /> : null}
      {/* `flex!`: o normalize.css que os SDKs da CAF injetam sem @layer traz `main { display: block }`,
          que vence o `flex` comum do Tailwind; o `Page` deixa de rolar e os botões do fim da tela somem.
          Só um `!important` em layer vence CSS sem layer, mesmo se uma folha da CAF escapar de
          use-combate-a-fraude. */}
      <main
        className="font-poppins flex! flex-col flex-1 h-screen-with-fallback overflow-hidden md:overflow-y-auto md:scrollbar-hidden md:relative"
        {...props}
      >
        {props.children}
      </main>
    </div>
  );
};
